import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmartDisplayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"smart_display"}/>
}
